import { combineLatest, from, of, Subscription } from 'rxjs';
import { catchError, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BrowserNtfService } from 'src/app/shared/services/browser-ntf.service';
import { RWDService } from '../../services/rwd.service';
import { ContextData, ContextType } from '../../services/models/context.data';
import { ContextDataService } from '../../services/context.data-service';
import { ContextCrossTabSyncService } from '../../services/context-cross-tab-sync.service';
import { UserStartRouteService } from '../../services/user-start-route.service';

@Component({
  selector: 'app-signed-in-layout',
  templateUrl: './signed-in-layout.component.html',
  styleUrls: ['./signed-in-layout.component.scss']
})
export class SignedInLayoutComponent implements OnInit, OnDestroy {
  public contextData: ContextData;
  public contextType: ContextType;

  private subscription = new Subscription();
  private redirecting = false;

  constructor(
    public rwdService: RWDService,
    private route: ActivatedRoute,
    private ctxDS: ContextDataService,
    private browserNtfService: BrowserNtfService,
    private contextCrossTabSyncService: ContextCrossTabSyncService,
    private userStartRoute: UserStartRouteService,
    private router: Router
  ) {
    this.contextData = this.route.parent!.snapshot.data.context;
    this.contextType = this.contextData.type;
  }

  ngOnInit(): void {
    this.browserNtfService.initialize();
    this.contextCrossTabSyncService.initialize();

    this.subscription.add(
      this.ctxDS.context$.subscribe((context) => {
        if (context) this.contextType = context;
      })
    );

    this.subscription.add(
      combineLatest([this.ctxDS.currentUser$, this.ctxDS.contextPerms$])
        .pipe(
          map(([user, permissions]) => [user?.id, JSON.stringify(permissions)] as const),
          distinctUntilChanged(([previousUser, previousPermissions], [userId, permissions]) =>
            previousUser === userId && previousPermissions === permissions
          ),
          switchMap(([userId]) =>
            userId ? from(this.userStartRoute.getModuleAccess(userId, false)).pipe(catchError(() => of(null))) : of(null)
          )
        )
        .subscribe((access) => {
          if (!access || access.hasCrmAccess || this.redirecting) return;
          this.redirecting = true;
          const userId = this.ctxDS.peekCurrentUserId();
          if (userId && access.offersCompanyId) {
            this.userStartRoute.activateOffersContext(userId, access.offersCompanyId);
            this.router.navigate(['/offers']);
          } else {
            this.router.navigate(['/signIn']);
          }
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
